import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
import { useIntl } from 'react-intl';

import AdminTermsListHeader from './ListHeader';
import AdminTermsListItem from './ListItem';

const AdminTermsList = ({
  terms,
  selectedTerms,
  timestamp,
  updateTermOnList,
  refreshTermList,
  deleteTermFromList,
  handleSelectTerm,
  taxonomy,
  orderBy,
  order,
  handleChangeOrder,
}) => {
  const intl = useIntl();

  return (
    <div className="table-wrapper">
      <Table className="users-list terms-list" responsive>
        <thead>
          <AdminTermsListHeader
            terms={terms}
            selectedTerms={selectedTerms}
            handleSelectTerm={handleSelectTerm}
            taxonomy={taxonomy}
            orderBy={orderBy}
            order={order}
            handleChangeOrder={handleChangeOrder}
          />
        </thead>
        <tbody>
          {terms.length > 0 && (
            terms.map(term => (
              <AdminTermsListItem
                key={term.id}
                term={term}
                selectedTerms={selectedTerms}
                timestamp={timestamp}
                updateTermOnList={updateTermOnList}
                refreshTermList={refreshTermList}
                deleteTermFromList={deleteTermFromList}
                handleSelectTerm={handleSelectTerm}
                taxonomy={taxonomy}
              />
            )))}
        </tbody>
      </Table>
      {terms.length === 0 && (
        <div className="nothing-found-wrapper nothing-found-table-wrapper">
          <h4>{intl.formatMessage({ defaultMessage: 'No tags found' })}</h4>
        </div>
      )}
    </div>
  );
};

AdminTermsList.propTypes = {
  taxonomy: PropTypes.object.isRequired,
  terms: PropTypes.array.isRequired,
  selectedTerms: PropTypes.array.isRequired,
  timestamp: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  order: PropTypes.string.isRequired,
  handleChangeOrder: PropTypes.func.isRequired,
  updateTermOnList: PropTypes.func.isRequired,
  refreshTermList: PropTypes.func.isRequired,
  deleteTermFromList: PropTypes.func.isRequired,
  handleSelectTerm: PropTypes.func.isRequired,
};

export default AdminTermsList;
